<template>
  <div class="hello">
    <div class="subTitle">遵义天立高中</div>
    <div class="payButton">
      <van-button
          v-for="item in payButtons"
          :key="item.label"
          round
          block
          size="large"
          icon="bill-o"
          :color="buttonGradient"
          class="pay-btn"
          @click="goTo(item.url)"
      >
        {{ item.label }}
      </van-button>
    </div>
  </div>
</template>


<script>
export default {
  name: 'tlgz',
  data() {
    return {
      // 按钮配置数组（可维护性强）
      payButtons: [
        {
          label: '学费',
          url: 'https://common-cspay.cibfintech.com/?data=xNfAx9eiKGd8f37edaf21f4373DFDz2lVKJtBURRNTDSxTDT14SduK+VxsIOMKWQE7IFb7HZf6raILtiWmUyw2lyLx7t2StOu+epoBAvbtyyz+EV/hxlj0lQX2a/GuIL2taw8Z8t9AHEvZyRsoEh+Z8ScYXRRT3OTomWYfZEPRTzK5VG4t8HN68iBq0='
        },
        {
          label: '素养费',
          url: 'https://common-cspay.cibfintech.com/?data=xNfAx9eiKGd8f37edaf21f4373DFDz2lVKJtBbEwGBWrAP6m7cPYGrdfFXFXkMuWCbuSxub8xMoQ4mtcpnULGwCwBIe12ScKdfUD0uY+Yebgk+Hs7N6Jf2CA'
        },
        {
          label: '综合服务',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmM3eND16mQeJJmP9FmS4Fu3ufyGfO1PplN6gkIH5lgsNU11NEmBo/x5vz1qn9xWhmB3AcltBYEWBhxHPt4I+adSs/S9+Ar5LJFsQJm1GD2vz3ZjjLudjUhLB2HqtuK0NN4bX/WI/MruPoWMCIqPWHKUA='
        }
      ],
      buttonGradient: 'linear-gradient(to right, #0055ff, #00aaff)',
    };
  },
  created() {
    document.title = '遵义天立高中';
  },
  methods: {
    goTo(url) {
      window.location.href = url;
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.subTitle {
  margin-top: 10px;
  font-size: 28px;
  padding-bottom: 16px;
  text-align: center;
}

.payButton {
  margin: 20px auto;
  width: 75vw;
}

.pay-btn {
  margin-bottom: 16px; /* 替代 br 和 div 高度 */
}
</style>

